export default __webpack_public_path__ + "static/media/squares.044cc79d.svg";